import { QueryKey } from 'constants/reactQuery';

export const rollingsQueryKey = {
  key: [QueryKey.Rolling],
  rolling: (rollingId: number) => [...rollingsQueryKey.key, rollingId] as const,
};
